import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getBookmark = ({ courseId, bookId }) =>
  httpClient.get(`${apis.GET_BOOKMARK}/${courseId}/${bookId}`);
